import { useToken } from '@chakra-ui/react';
import type { CustomIconProps } from '../types';

const AddToBag = ({
    width,
    height,
    backgroundColor = 'slt-pepper.900',
    color = 'white',
}: CustomIconProps): JSX.Element => {
    const resolvedBackgroundColor = useToken('colors', backgroundColor, backgroundColor);
    const resolvedColor = useToken('colors', color, color);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? '40'}
            height={height ?? '40'}
            viewBox="0 0 40 40"
            fill="none"
        >
            <path
                d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                fill={resolvedBackgroundColor}
            />
            <path
                d="M26.001 22.2969C26.3893 22.2969 26.7041 22.6139 26.7041 23.0039V24.8574H28.5459C28.9342 24.8574 29.249 25.1735 29.249 25.5635C29.2489 25.9534 28.9342 26.2695 28.5459 26.2695H26.7041V28.2109C26.7041 28.6009 26.3893 28.917 26.001 28.917C25.6126 28.917 25.2979 28.6009 25.2979 28.2109V26.2695H23.3604C22.9721 26.2695 22.6573 25.9534 22.6572 25.5635C22.6572 25.1735 22.972 24.8574 23.3604 24.8574H25.2979V23.0039C25.2979 22.6139 25.6126 22.2969 26.001 22.2969ZM19.9902 10C20.9638 10 21.7501 10.2262 22.3691 10.6309C22.9874 11.0351 23.3901 11.5855 23.6494 12.1523C24.0279 12.9796 24.1166 13.8838 24.1377 14.5225H29.9951L29.208 20.9551C28.7955 20.6818 28.3469 20.4598 27.8711 20.2959L28.4053 15.9346H24.1455V18.6865C24.1455 19.0764 23.8306 19.3924 23.4424 19.3926C23.054 19.3926 22.7393 19.0765 22.7393 18.6865V15.9346H17.2412V18.6865C17.2412 19.0765 16.9264 19.3926 16.5381 19.3926C16.1498 19.3925 15.835 19.0765 15.835 18.6865V15.9346H11.585L12.832 26.1338C12.8971 26.6646 13.3464 27.0632 13.8789 27.0635H20.1211C20.216 27.5587 20.3712 28.0322 20.5801 28.4756H13.8789C12.6359 28.4754 11.5881 27.5446 11.4365 26.3057L9.99512 14.5225H15.8447C15.8695 13.9236 15.9637 13.0486 16.3281 12.2314C16.5842 11.6574 16.9825 11.089 17.5986 10.667C18.2179 10.2428 19.0083 10 19.9902 10ZM19.9902 11.4121C19.2464 11.4121 18.7421 11.5932 18.3906 11.834C18.036 12.077 17.7867 12.4153 17.6113 12.8086C17.3553 13.3826 17.2772 14.0228 17.2529 14.5225H22.7295C22.7085 13.9773 22.6355 13.318 22.3721 12.7422C22.1999 12.366 21.9549 12.0449 21.6025 11.8145C21.2509 11.5845 20.7423 11.4121 19.9902 11.4121Z"
                fill={resolvedColor}
            />
        </svg>
    );
};
export default AddToBag;
